import { useMutation, useQuery } from "@tanstack/react-query";
import API from "../../api/api";
import axios from "axios";
import { BASE_URL, DEFAULT_KEY } from "../../config/config";

const callApi = async (endpoint) => {
    try {
        const response = await API.get(endpoint);
        if (response.status === 200) {
            return response?.data?.data;
        } else {
            return response?.data?.data;
        }
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const EwalletService = {
    callTiles: async () => {
        return callApi("ewallet-tiles");
    },
    callStatement: async (page, itemsPerPage, sortBy, direction) => {
        return callApi(
            `ewallet-statement?page=${page}&perPage=${itemsPerPage}&sortBy=${sortBy}&direction=${direction}`
        );
    },
    callTransferHistory: async (
        page,
        itemsPerPage,
        selectedCategory,
        startDate,
        endDate,
        sortBy,
        direction
    ) => {
        return callApi(
            `/ewallet-transfer-history?type=${selectedCategory}&startDate=${startDate}&endDate=${endDate}&page=${page}&perPage=${itemsPerPage}&sortBy=${sortBy}&direction=${direction}`
        );
    },
    callPurchaseHistory: async (page, itemsPerPage, sortBy, direction) => {
        return callApi(
            `purchase-wallet?page=${page}&perPage=${itemsPerPage}&sortBy=${sortBy}&direction=${direction}`
        );
    },
    callMyEarnings: async (
        page,
        itemsPerPage,
        selectedCategory,
        startDate,
        endDate,
        sortBy,
        direction
    ) => {
        return callApi(
            `my-earnings?page=${page}&perPage=${itemsPerPage}&startDate=${startDate}&endDate=${endDate}&type=${selectedCategory}&sortBy=${sortBy}&direction=${direction}`
        );
    },
    callEwalletBalance: async () => {
        return callApi("get-ewallet-balance");
    },
    callFundTransfer: async (data) => {
        return API.post("fund-transfer", JSON.stringify(data))
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    },
    useEmoneyTiles: () => {
        return useQuery({
            queryKey: ["emoney-tiles"],
            queryFn: () => callApi("get-emoney-tiles"),
        });
    },
    useEmoneyRequestHistory: (page, itemsPerPage, activeTab) => {
        return useQuery({
            queryKey: ["get-request-emoney", page, itemsPerPage, activeTab],
            queryFn: () => callApi(`get-request-emoney?page=${page}&perPage=${itemsPerPage}`),
            enabled: activeTab === 'emoney_request'
        });
    },
    useEmoneyTransfer: (page, itemsPerPage, activeTab) => {
        return useQuery({
            queryKey: ["get-emoney-transfer", page, itemsPerPage, activeTab],
            queryFn: () => callApi(`get-emoney-transfer?page=${page}&perPage=${itemsPerPage}`),
            enabled: activeTab === 'emoney_transfer'
        });
    },
    useEmoneyStatement: (page, itemsPerPage, activeTab) => {
        return useQuery({
            queryKey: ["get-emoney-statement", page, itemsPerPage, activeTab],
            queryFn: () => callApi(`get-emoney-statement?page=${page}&perPage=${itemsPerPage}`),
            enabled: activeTab === 'statement'
        });
    },
    useSilverReport: (page, itemsPerPage, activeTab, startDate = '', endDate = '', userType, pairs) => {
        return useQuery({
            queryKey: ["get-silver-report", page, itemsPerPage, activeTab, startDate, endDate, userType, pairs],
            queryFn: () => callApi(`get-silver-report?page=${page}&perPage=${itemsPerPage}&startDate=${startDate}&endDate=${endDate}&userType=${userType}&pairs=${pairs}`),
            enabled: activeTab === 'statement'
        });
    },
    useRequestEmoney: () => {
        const customAxios = axios.create({ baseURL: BASE_URL });
        customAxios.defaults.headers.common["api-key"] = localStorage.getItem("api-key") || DEFAULT_KEY;
        customAxios.defaults.headers.common["access-token"] = localStorage.getItem("access-token") || "";
        customAxios.defaults.headers.common["Content-Type"] = "multipart/form-data";
        return useMutation(async (formData) => {
            try {
                const response = await customAxios.post(
                    `request-emoney`,
                    formData
                );
                return response.data;
            } catch (error) {
                return error?.response?.data;
            }
        },
        );
    }
};